import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraEmptyState } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { ShieldOff } from 'lucide-react';
import { Outlet, useSearchParams } from 'react-router-dom';
import { useWorkflowAreas } from '../lib/access/useWorkflowAreas';
import { ReleaseHistory } from '../pages/Library/ReleaseHistory';
import { PageBody } from './layout';
/**
 * Route guard for the Growth workflows (Pursuits, Opportunities, Landscapes,
 * Library): its child routes mount only where useWorkflowAreas finds the area
 * reachable — the same gate the app rail uses, which is the landing page's own
 * server gate. Without it the shell rendered in full (New buttons, tabs) and
 * every call behind it refused. Nothing renders while access resolves.
 */ export function RequireWorkflowArea({ area }) {
    const { isLoading, reachable } = useWorkflowAreas();
    const [params] = useSearchParams();
    const historyId = area === 'library' ? params.get('history') : null;
    // Audience membership permits bounded history independently of source or
    // general Library access. The server rechecks every returned version.
    if (historyId) {
        return /*#__PURE__*/ _jsx(PageBody, {
            children: /*#__PURE__*/ _jsx(ReleaseHistory, {
                itemId: historyId
            }, historyId)
        });
    }
    if (isLoading) return null;
    // An array admits a viewer who can reach any of its areas.
    if (![
        area
    ].flat().some((a)=>reachable[a])) {
        return /*#__PURE__*/ _jsx(PageBody, {
            children: /*#__PURE__*/ _jsx(SpecraEmptyState, {
                "data-testid": Testids.appNav.areaDenied,
                description: "This is Growth information. Ask an admin for Growth access.",
                framed: true,
                icon: /*#__PURE__*/ _jsx(ShieldOff, {}),
                title: "No Growth access"
            })
        });
    }
    return /*#__PURE__*/ _jsx(Outlet, {});
}
